const adminEndpoints = [
    "/api/v1/admin",
    "/api/internal",
    "/.spire/",
    "/admin/",
    "/userfiles/_system",
    "/.spire/generateBlueprintTranslations",
] as const;

const excludeFromAdminEndpoints = [".spire/shareEntity"] as const;

export const isAdminEndpoint = (endpoint: string) =>
    adminEndpoints.filter(a => endpoint.toLowerCase().includes(a)).length > 0 &&
    excludeFromAdminEndpoints.filter(a => endpoint.toLowerCase().includes(a.toLowerCase())).length === 0;
